export default __webpack_public_path__ + "static/media/tracklink-icon.668fcb8a.svg";